import { ReactNode } from 'react';
import { BaseFormField } from 'types/form/baseFormField';
import { ErrorMessage, Field, Label } from './fragments/FieldSet';
import { MessagesTooltip } from 'components/feedback/MessagesTooltip';
import { InfoIcon } from 'components/icons/Icons';

export interface InputBase {}

interface FormFieldProps extends BaseFormField {
  children: ReactNode;
}

export const FormField = ({
  label,
  labelTooltip,
  error,
  required,
  name,
  children
}: FormFieldProps) => {
  const isError = Boolean(error);

  return (
    <Field>
      {label && (
        <div className="flex items-center gap-1.5">
          <Label htmlFor={name} required={required}>
            {label}
          </Label>
          {labelTooltip && (
            <MessagesTooltip sections={[{ type: 'info', messages: [labelTooltip] }]}>
              <InfoIcon className="w-4 h-4 text-primary cursor-help" />
            </MessagesTooltip>
          )}
        </div>
      )}
      {children}
      {isError && <ErrorMessage>{error}</ErrorMessage>}
    </Field>
  );
};
